<template>
  <div
    style="max-width: 700px"
    class="mx-auto"
  >
    <div
      v-if="$page.props.user.teams.length > 1"
      class="text-right"
    >
      <v-menu offset-y>
        <template #activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
          >
            {{ $t('Switch team') }}
            <v-icon right>
              mdi-chevron-down
            </v-icon>
          </v-btn>
        </template>
        <switch-team-list />
      </v-menu>
    </div>

    <team-member-usage />

    <update-team-name-form
      :team="team"
      :permissions="permissions"
      class="mb-4"
    />

    <invite-team-member-form
      v-if="permissions.canAddTeamMembers || $page.props.user.is_demo || !$page.props.user.verified"
      :team="team"
      class="mb-4"
    />

    <v-card v-if="team.invitations.length > 0 && permissions.canAddTeamMembers">
      <v-card-title>{{ $t('Pending team invitations') }}</v-card-title>
      <v-card-subtitle>
        {{ $t('These people have been invited to your team and have been sent an invitation email. They may join the team by accepting the email invitation.') }}
      </v-card-subtitle>
      <pending-invitations-list
        :can-cancel-invitations="permissions.canRemoveTeamMembers"
        :invitations="team.invitations"
      />
    </v-card>

    <manage-team-members
      v-if="team.users.length > 0"
      :team="team"
      :members="team.users"
      :permissions="permissions"
    />
  </div>
</template>

<script>
import ManageTeamMembers from '@/components/team/ManageTeamMembers';
import InviteTeamMemberForm from '@/components/team/InviteTeamMemberForm';
import UpdateTeamNameForm from '@/components/team/UpdateTeamNameForm';
import PendingInvitationsList from '@/components/team/PendingInvitationsList';
import Layout from '@/components/shared/TheLayout';
import TabsLayout from '@/components/team/TabsLayout';
import i18n from '@/plugins/vue-i18n';

export default {
  components: {
    UpdateTeamNameForm,
    InviteTeamMemberForm,
    ManageTeamMembers,
    PendingInvitationsList
  },

  layout: (h, page) => h(Layout, {
    props: {
      noWrappingContainer: true,
      pageTitle: i18n.t('Team management')
    }
  }, [h(TabsLayout, {
    props: {
      activeTab: 'show',
      team: page.data.props.team
    }
  }, [page])]),

  props: {
    team: {
      type: Object,
      required: true
    },
    permissions: {
      type: Object,
      required: true
    }
  }
}
</script>